<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="1000">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-format-list-bulleted</v-icon> Avaliação de Formação
          </div>
        </v-toolbar>
        <div class="container dialog pt-6">
            <v-row>
                <h1>Avaliação de Formação</h1>
            </v-row>
            <v-row>
              <v-col cols="12" class="pl-6 pr-6">
                <p>Por favor, responda as perguntas abaixo.</p>
              </v-col>
            </v-row>
            <v-row v-if="existeNota1a5">
              <v-col cols="12" class="pl-6 pr-6">
                <p>
                  Por favor, atribua uma nota de 1 a 5 para cada pergunta abaixo, onde: <br>
                  1 = Não satisfeito <br>
                  10 = Muito satisfeito.
                </p>
              </v-col>
            </v-row>

            <QuestionarioDinamico
              v-if="questoes.length > 0"
              :questoes="questoes"
              :exibirErros="exibirErros"
              :disabled="provaRealizada"
              @update="onUpdateQuestao"
            />
          <v-row v-if="provaRealizada" class="d-flex justify-center mb-4" >
            <v-btn color="primary" class="mr-3" @click="baixarAvaliacaoPdf()">Baixar Avaliação</v-btn>
            <v-btn outlined color="primary" @click="$emit('onClose')">Fechar</v-btn>
          </v-row>
          <v-row v-else class="d-flex justify-center mb-4" >
            <v-btn color="primary" class="mr-3" @click="salvar">Salvar</v-btn>
            <v-btn outlined color="primary" @click="$emit('onClose')">Cancelar</v-btn>
          </v-row>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { HistoricoFormacao } from "~/commons/classes/historico-formacao";
import ManterHistoricoFormacaoService from "~/services/manter-historico-formacao.service";
import QuestionarioDinamico from './components/QuestionarioDinamico.vue';
export default {
  mixins: [ManterHistoricoFormacaoService],
  components: {
    QuestionarioDinamico
  },
  props: new DialogProps(HistoricoFormacao),
  data() {
    return {
      exibirErros: false,
      questoes: [],
      provaRealizada: false,
    };
  },
  computed: {
  existeNota1a5() {
    return this.questoes.some(q => q.tipo === "Nota 1 a 5");
    }
  },

  mounted() {
    this.questoes = this.content.questoes || [];
    this.provaRealizada = this.questoes.some(questao => questao.resposta && questao.resposta !== "") || this.content.passouSeteDias;
  },
  methods: {
    salvar() {
      if(this.Validar() ) {
        this.exibirErros = true;
        return;
      }
      const save = () => {
        return this.$swal({
          text: `Deseja confirmar essa operação?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: `Confirmar`,
          cancelButtonText: `Cancelar`,
        }).then(() => {
          const pay = this.getPayload();
          return this.$enviarRespostasAvaliacao(pay, this.content.avaliacaoId);
        });
      };

      save().then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.$emit("onClose");
          this.$emit("onSave");
        })
    },
    getPayload() {
      return {
        avaliacaoId: this.content.avaliacaoId,
        formacaoId: this.content.id,
        respostas: this.questoes.map((pergunta) => {
          return {
            questaoId: pergunta?.questaoId || null,
            resposta: pergunta.resposta ? String(pergunta.resposta) : "",
          };
        }),
      };
    },
    onUpdateQuestao({ idx, resposta }) {
      this.questoes[idx].resposta = resposta;
    },
    Validar() {
      const valid = this.questoes.every(questao => {
        if (questao.obrigatoria) {
          return questao.tipo === 'Aberta' ? !!questao.resposta?.trim() : questao.resposta !== null && questao.resposta !== '' && questao.resposta !== undefined;
        }
        return true;
        });

      if (!valid) {
        this.$notifyError('Preencha todos os campos obrigatórios');
        return true;
      }
    },
    async baixarAvaliacaoPdf() {
      this.showPageLoading();
      try {
        const { data } = await this.$obterAvaliacaoPDF(this.$montarParamsFilters({FormacaoId: this.content?.id, avaliacaoId: this.content?.avaliacaoId}));
        const url = URL.createObjectURL(data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "SIGFOCO.AvaliacaoFormacao.pdf");
        document.body.appendChild(link);
        link.click();
        this.$notifySuccess("Operação realizada com sucesso.");
        } finally {
        this.hidePageLoading();
      }
    },
  },
  }
</script>
